import isString from 'lodash/isString';
import dateFnsFormat from 'date-fns/format';
import parse from 'date-fns/parseISO';
import addDays from 'date-fns/addDays';
import subDays from 'date-fns/subDays';
import startOfToday from 'date-fns/startOfToday';
import isBefore from 'date-fns/isBefore';
import isSameDay from 'date-fns/isSameDay';
import isValid from 'date-fns/isValid';
import isWithinInterval from 'date-fns/isWithinInterval';
import differenceInDays from 'date-fns/differenceInDays';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import differenceInCalendarMonths from 'date-fns/differenceInCalendarMonths';
import { SEARCH_DATE_FORMAT } from 'config';

export const format = (date, format = SEARCH_DATE_FORMAT) => {
  const formattedDate = dateFnsFormat(date, format);
  return isString(formattedDate) ? formattedDate : null;
};

export {
  parse,
  addDays,
  subDays,
  startOfToday,
  isBefore,
  isSameDay,
  isValid,
  isWithinInterval,
  differenceInDays,
  differenceInCalendarDays,
  differenceInCalendarMonths,
};
